import NavigationTop from "../../components/NavigationTop/NavigationTop";
import MainShare from "../../components/MainShare/MainShare";
import styles from "./HowTo.module.css";
import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchHowToGallery } from "../../store/slices/gallerySlice";
import backstageImg from "../../assets/images/backstageTest.png";
import cardPaidImg from "../../assets/images/howto/card-paid.png";
import cardFreeImg from "../../assets/images/howto/card-free.png";
import darkphotoImg from "../../assets/images/howto/darkphoto.png";
import sensorsBannerImg from "../../assets/images/howto/sensors-banner.png";
import sensors1Img from "../../assets/images/howto/sensors-1.png";
import sensors2Img from "../../assets/images/howto/sensors-2.png";
import sensorComparisonImg from "../../assets/images/howto/sensor-comparison.png";
import lensdataBannerImg from "../../assets/images/howto/lensdata-banner.png";
import lensdataFormatsImg from "../../assets/images/howto/lensdata-formats.png";
import backstage1Img from "../../assets/images/howto/backstage-1.png";
import backstage2Img from "../../assets/images/howto/backstage-2.png";
import backstageWideImg from "../../assets/images/howto/backstage-wide.png";
import witnessImg from "../../assets/images/howto/witness.png";
import textversionImg from "../../assets/images/howto/textversion.png";
import shootingBannerImg from "../../assets/images/howto/shooting-banner.png";
import conversionBannerImg from "../../assets/images/howto/conversion-banner.png";
import tableSmokeImg from "../../assets/images/howto/table-smoke.png";
import gallery1 from "../../assets/images/howto/gallery/gallery-1.jpg";
import gallery2 from "../../assets/images/howto/gallery/gallery-2.jpg";
import gallery3 from "../../assets/images/howto/gallery/gallery-3.jpg";
import gallery4 from "../../assets/images/howto/gallery/gallery-4.jpg";
import gallery5 from "../../assets/images/howto/gallery/gallery-5.jpg";
import gallery6 from "../../assets/images/howto/gallery/gallery-6.jpg";
import gallery7 from "../../assets/images/howto/gallery/gallery-7.jpg";
import gallery8 from "../../assets/images/howto/gallery/gallery-8.jpg";
import gallery9 from "../../assets/images/howto/gallery/gallery-9.jpg";
import gallery10 from "../../assets/images/howto/gallery/gallery-10.jpg";
import gallery11 from "../../assets/images/howto/gallery/gallery-11.jpg";
import gallery12 from "../../assets/images/howto/gallery/gallery-12.jpg";
import gallery13 from "../../assets/images/howto/gallery/gallery-13.jpg";
import gallery14 from "../../assets/images/howto/gallery/gallery-14.jpg";

const DEFAULT_GALLERY_IMAGES = [
  gallery1, gallery2, gallery3, gallery4, gallery5, gallery6, gallery7,
  gallery8, gallery9, gallery10, gallery11, gallery12, gallery13, gallery14,
];

const HowTo = () => {
  // const [galleryIdx, setGalleryIdx] = useState(0);
  const dispatch = useDispatch();
  const { howtoGalleryImages, status } = useSelector((state) => state.howtoGallery);
  const [galleryIdx, setGalleryIdx] = useState(0);

  useEffect(() => {
    dispatch(fetchHowToGallery());
  }, [dispatch]);

  // Use gallery from Redux if available, otherwise use default images
  const galleryImages = howtoGalleryImages && howtoGalleryImages.length > 0
    ? howtoGalleryImages.map(img => img.image)
    : DEFAULT_GALLERY_IMAGES;
  const GALLERY_TOTAL = galleryImages.length;

  useEffect(() => {
    if (galleryIdx >= GALLERY_TOTAL && GALLERY_TOTAL > 0) {
      setGalleryIdx(0);
    }
  }, [GALLERY_TOTAL, galleryIdx]);

  const prevSlide = () => setGalleryIdx((p) => (p === 0 ? GALLERY_TOTAL - 1 : p - 1));
  const nextSlide = () => setGalleryIdx((p) => (p === GALLERY_TOTAL - 1 ? 0 : p + 1));

  const bg = (img, overlay = true) => ({
    backgroundImage: overlay
      ? `url(${img})`
      : `url(${img})`,
    backgroundSize: "cover",
    // backgroundPosition: "center",
  });

  return (
    <div className={styles.page}>
      <Helmet>
        <title>Distortion Grids Database – How It Works</title>
        <meta name="description" content="See how we capture high-resolution lens grids and validate every grid for sub-pixel accuracy before release." />
        <meta property="og:title" content="Distortion Grids Database – How It Works" />
        <meta property="og:description" content="See how we capture high-resolution lens grids and validate every grid for sub-pixel accuracy before release." />
      </Helmet>

      <NavigationTop title={"How it works"} />

      {/* ── 1. Promo Video ── */}
      <section className={`${styles.contentSection} ${styles.firstContentSection}`}>
        <div className={styles.videoWrapper}>
          <iframe
            src="https://www.youtube.com/embed/4HUVDlopWxk"
            title="Matchmove machine Promo"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className={styles.videoIframe}
          />
        </div>
      </section>

      {/* ── Products Banner ── */}
      <div className={`${styles.fullBanner} ${styles.productsBanner}`} style={bg(backstageImg)}>
        <h2>Products</h2>
      </div>

      {/* ── 2. Products ── */}
      <section className={styles.contentSection}>
        <p className={styles.subtitle}>The library includes both paid and free products.</p>
        <div className={styles.productsGrid}>
          <div className={styles.productCol}>
            <p className={styles.bodyText}>
              <strong>Paid products</strong> are prepared by our studio - we're confident in them and guarantee their quality.
            </p>
            <img src={cardPaidImg} alt="Paid product card" className={styles.productCardImg} />
          </div>
          <div className={styles.productCol}>
            <p className={styles.bodyText}>
              <strong>Free products</strong> are uploaded by users. We can't verify their accuracy, so we believe it's fair to offer them at no cost.
            </p>
            <img src={cardFreeImg} alt="Free product card" className={styles.productCardImg} />
          </div>
        </div>
        <div className={styles.infoBar} style={{'--smoke-bg': `url(${tableSmokeImg})`}}>
          <div className={styles.infoIcon}>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none"><circle cx="20" cy="20" r="20" fill="#2F57BF"/><text x="20" y="27" textAnchor="middle" fill="#fff" fontSize="22" fontWeight="700" fontFamily="Arial, sans-serif">i</text></svg>
          </div>
          <p>Each paid product includes one <strong>free asset:</strong> an OpenGate grid shot at <strong>infinity focus</strong> (for zoom lenses: infinity focus at the <strong>shortest focal length</strong>).</p>
        </div>
        <div className={styles.darkPhoto}  >
          <img src={darkphotoImg} alt="Dark Photo" />
        </div>
      </section>

      {/* ── Sensors Banner ── */}
      <div className={`${styles.fullBanner} ${styles.sensorsBanner}`} style={bg(sensorsBannerImg)}>
        <h2>Sensors</h2>
      </div>

      {/* ── 3. Sensors ── */}
      <section className={styles.contentSection}>
        <p className={styles.subtitle}>For preparing our assets, we used the largest sensors available to us:</p>
        <ul className={styles.bulletList}>
          <li>RED Monstro 8K VV — 40.960 × 21.600 mm</li>
          <li>ARRI Alexa Mini LF — 36.696 × 25.542 mm</li>
        </ul>
        <div className={styles.imageRow}>
          <div className={styles.halfImg} style={bg(sensors1Img)} />
          <div className={styles.halfImg} style={bg(sensors2Img)} />
        </div>
        <p className={styles.bodyText}>These cover the majority of shooting formats from other manufacturers.</p>
        <p className={styles.bodyText}>Here is the comparison of the biggest sensors for the most popular camera brands.</p>
        <div className={styles.sensorCompImg} style={bg(sensorComparisonImg, false)} />
        <p className={styles.bodyText}>You can also use tools from <a href="https://cvp.com/tools/cameralens" target="_blank" rel="noopener noreferrer" className={styles.inlineLink}>CVP</a> and <a href="https://phfx.com/tools/formatCompare/" target="_blank" rel="noopener noreferrer" className={styles.inlineLink}>PHFX</a> for easier sensor comparison.</p>
      </section>

      {/* ── Lens Data Banner ── */}
      <div className={`${styles.fullBanner} ${styles.lensDataBanner}`} style={bg(lensdataBannerImg)}>
        <h2>Lens Data</h2>
      </div>

      {/* ── 4. Lens Data ── */}
      <section className={styles.contentSection}>
        <p className={styles.bodyText}>Some lenses had an <a href="https://www.arri.com/en/learn-help/learn-help-camera-system/frequently-asked-questions/lens-data-system-faq" target="_blank" rel="noopener noreferrer" className={styles.inlineLink}>LDS</a> system (or an equivalent), which allowed us to quickly capture the full focus-distance range.</p>
        <p className={styles.bodyText}>Reminder: lens distortion can depend on <strong>focus distance</strong> as well — this is the so-called <strong>lens breathing</strong> effect.</p>
        <div className={styles.lensDataRow}>
          <div className={styles.videoWrapperHalf}>
            <iframe
              src="https://www.youtube.com/embed/1-mZ7jiA8ws"
              title="Lens Data"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className={styles.videoIframe}
            />
          </div>
          <img src={lensdataFormatsImg} alt="Lens formats" className={styles.lensFormatsImg} />
        </div>

        {/* ── Backstage images ── */}
        <div className={styles.imageRow}>
          <div className={styles.halfImg} style={bg(backstage1Img)} />
          <div className={styles.halfImg} style={bg(backstage2Img)} />
        </div>
        <div className={styles.wideImg} style={bg(backstageWideImg)} />

        {/* ── 5. Witness Camera ── */}
        <p className={styles.bodyText} >
          For lenses that couldn't provide metadata, we added a <strong>witness camera</strong> to the rig,
          <strong> timecode-synced</strong> with the main camera. This let us capture the full range of focus
          distances <strong>in a single pass</strong>, without stopping the recording for each next step.
        </p>
        <div className={styles.imageRow}>
          <div className={styles.halfImg} style={bg(witnessImg)} />
          <div className={styles.videoWrapperHalf}>
            <iframe
              src="https://www.youtube.com/embed/G-H-TXd9WBU"
              title="Witness Camera"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className={styles.videoIframe}
            />
          </div>
        </div>
      </section>

      {/* ── Shooting Technique Banner ── */}
      <div className={`${styles.fullBanner} ${styles.shootingBanner}`} style={bg(shootingBannerImg)}>
        <h2>Shooting Technique</h2>
      </div>

      {/* ── 6. Shooting Technique content ── */}
      <section className={styles.contentSection}>
        <p className={styles.bodyText}>
          During filming, we follow our comprehensive step-by-step guide on how to shoot distortion grids:
        </p>
        <div className={`${styles.imageRow} ${styles.videoTextRow}`}>
          <div className={styles.videoWrapperHalf}>
            <iframe
              src="https://www.youtube.com/embed/nVXqJNFzpoo"
              title="How to shoot Distortion Grids"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className={styles.videoIframe}
            />
          </div>
          <div className={styles.textVersionCard} style={bg(textversionImg)}>
            <a
              href="https://matchmovemachine.com/howto/"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.textVersionBtn}
            >
              Text version
            </a>
          </div>
        </div>
        <p className={styles.bodyText}>
          Because we recorded focus distances as a <strong>single smooth pass</strong> rather than discrete stops, we could later choose the exact distances where distortion changed noticeably during processing.
        </p>
        {/*<p className={styles.bodyText}>*/}
        {/*  Average number of steps (keyframes) when creating a lens preset in 3DEqualizer:*/}
        {/*</p>*/}
        {/*<table className={styles.lensTable}>*/}
        {/*  <thead className={styles.smokeHead} style={{'--smoke-bg': `url(${tableSmokeImg})`}}>*/}
        {/*    <tr>*/}
        {/*      <th><span>Lens Type</span></th>*/}
        {/*      <th><span>Focal Length</span></th>*/}
        {/*      <th><span>Steps</span></th>*/}
        {/*      <th><span>Notes</span></th>*/}
        {/*    </tr>*/}
        {/*  </thead>*/}
        {/*  <tbody>*/}
        {/*    <tr><td>Prime</td><td>24 mm</td><td>12</td><td>Minimal distortion</td></tr>*/}
        {/*    <tr><td>Prime</td><td>35 mm</td><td>14</td><td>Moderate distortion</td></tr>*/}
        {/*    <tr><td>Prime</td><td>50 mm</td><td>16</td><td>Non-linear correction</td></tr>*/}
        {/*    <tr><td>Zoom</td><td>24–70 mm</td><td>28</td><td>Zoom-dependent distortion</td></tr>*/}
        {/*    <tr><td>Zoom</td><td>70–200 mm</td><td>32</td><td>Increased complexity</td></tr>*/}
        {/*    <tr><td>Anamorphic</td><td>50 mm</td><td>36</td><td>Asymmetrical distortion</td></tr>*/}
        {/*    <tr><td>Anamorphic</td><td>75 mm</td><td>40</td><td>Strong lens breathing</td></tr>*/}
        {/*  </tbody>*/}
        {/*</table>*/}
        {/*<p className={styles.bodyText}>*/}
        {/*  Focus-distance steps as a percentage of the lens's full range:*/}
        {/*</p>*/}
      </section>

      {/* ── Conversion and Optimization Banner ── */}
      <div className={`${styles.fullBanner} ${styles.conversionBanner}`}
        style={{
          ...bg(conversionBannerImg),
          backgroundPosition: "50% 50%"
          }}>
        <h2>Conversion and Optimization</h2>
      </div>

      {/* ── 7. Final text ── */}
      <section className={styles.contentSection}>
        <p className={styles.bodyText}>
          We adapted our Open Gate grids to the most popular formats (don't confuse pixel
          resolution with format — they don't always map 1:1) using our <a href="https://grids.matchmovemachine.com/tutorials/how-to-properly-crop-distortion-grids " target="_blank" rel="noopener noreferrer" className={styles.inlineLink}>grid preparation tool</a>.
        </p>
        <p className={styles.bodyText}>
          Next, we ran a series of tests and determined the optimal file format, compression, and
          colorspace to make downloading as convenient as possible. Details are covered <a href="https://grids.matchmovemachine.com/tutorials/prepare-and-save-your-grids-1" target="_blank" rel="noopener noreferrer" className={styles.inlineLink}>in our tutorial</a>.
        </p>
        <p className={styles.bodyText}>Enjoy,<br/>and Have a Good Solve!</p>
      </section>

      <section className={styles.contentSection}>
        <div className={styles.videoWrapper}>
          <iframe
            src="https://www.youtube.com/embed/1GbGWvykOSc"
            title="Matchmove machine Promo"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className={styles.videoIframe}
          />
        </div>
      </section>

      {/* ── Image Gallery / Slider ── */}
      <section className={styles.gallery}>
        {status === 'loading' ? (
          <div className={styles.gallerySlide} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f0f0f0' }}>
            <p style={{ color: '#999' }}>Загрузка галереи...</p>
          </div>
        ) : (
          <>
            <div className={styles.gallerySlide} style={bg(galleryImages[galleryIdx])} />

            <div className={styles.galleryOverlay}>
              <div className={styles.galleryControlsContainer}>
                <button className={`${styles.galleryArrow} ${styles.galleryArrowLeft}`} onClick={prevSlide} aria-label="Previous" disabled={status === 'loading'}>
                  <svg width="35" height="8" viewBox="0 0 35 8" fill="none">
                    <path d="M0 4h35M0 4l4-4M0 4l4 4" stroke="#2F57BF" strokeWidth="2"/>
                  </svg>
                </button>

                <div className={styles.galleryDots}>
                  {Array.from({ length: GALLERY_TOTAL }).map((_, i) => (
                    <span
                      key={i}
                      className={`${styles.dot} ${i === galleryIdx ? styles.dotActive : ""}`}
                      onClick={() => setGalleryIdx(i)}
                      style={{ cursor: status === 'loading' ? 'not-allowed' : 'pointer', opacity: status === 'loading' ? 0.5 : 1 }}
                    />
                  ))}
                </div>

                <button className={`${styles.galleryArrow} ${styles.galleryArrowRight}`} onClick={nextSlide} aria-label="Next" disabled={status === 'loading'}>
                  <svg width="35" height="8" viewBox="0 0 35 8" fill="none">
                    <path d="M35 4H0M35 4l-4-4M35 4l-4 4" stroke="#2F57BF" strokeWidth="2"/>
                  </svg>
                </button>
              </div>
            </div>
          </>
        )}
      </section>

    </div>
  );
};

export default HowTo;
